<div class="form-check mb-3">
  <input
    type="checkbox"
    id="showDescriptions"
    class="form-check-input"
    [disabled]="isTogglingConsent"
    [checked]="user.consentForSessionRecordings"
    (change)="toggleConsent($event)"
    />
  <label
    for="showDescriptions"
    class="form-label form-check-label"
    [class.text-muted]="isTogglingConsent"
    i18n="
      Text for consent checkbox during onboarding@@onboarding-consent-checkbox"
    >
    I agree to Maptio creating session recordings of my activity so the team can
    use them - only to improve the product, never to share in public
  </label>
</div>

@if (hasTogglingConsentFailed) {
  <div
    class="alert alert-danger"
    role="alert"
  i18n="
    Error text for consent checkbox during onboarding@@onboarding-consent-error"
    >
  There was an error when updating consent. You can chat with us or email us at
  <a href="mailto:support@maptio.com?subject=Error when updating consent">
    support&#64;maptio.com
  </a>
  if you'd like to report the issue and notify us of your consent preferences.
</div>
}
